import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver-es';
import * as XLSX from 'xlsx-js-style';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  readonly defaultFileName = 'LIVE_CCJ_Console';
  readonly excelExtension = '.xlsx';
  readonly txtExtension = '.txt';

  constructor() {
  }

  /**
   * Export data as excel file
   * @param data
   * @param fileName
   * @param wrapTextCols example ['A', 'B', 'C']
   * @param maxWidthCols example [10, 20, 100]
   */
  exportExcel(
    data: any[],
    fileName: string,
    wrapTextCols: string[] = [],
    maxWidthCols: number[] = []
  ) {
    const chunkFileName: any[] = fileName.split('.');
    const name: string = chunkFileName[0] || this.defaultFileName;
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    // Apply wrapText style
    if (wrapTextCols.length) {
      for (const wsKey in ws) {
        if (ws.hasOwnProperty(wsKey)) {
          if (typeof(ws[wsKey]) !== 'object') continue;
          if (!this.isWrapTextColumn(wrapTextCols, wsKey)) continue;
          ws[wsKey].s = { alignment: { wrapText: true } };
        }
      }
    }
    // Apply maxWidth cols
    if (maxWidthCols.length) {
      const wsCols = [];
      maxWidthCols.forEach(maxWidthCol => {
        if (maxWidthCol > 0) {
          wsCols.push({ wch: maxWidthCol + 5 })
        }
      });
      ws['!cols'] = wsCols;
    }
    const wb: XLSX.WorkBook = { Sheets: { ['Sheet1']: ws }, SheetNames: ['Sheet1'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob: Blob = new Blob(
      [excelBuffer],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' },
    );
    saveAs(blob, name + this.excelExtension);
  }

  /**
   * Export data as txt file
   * @param data
   * @param fileName
   */
  exportTxt(data: string, fileName: string) {
    const chunkFileName: any[] = fileName.split('.');
    const name: string = chunkFileName[0] || this.defaultFileName;
    const blob: Blob = new Blob([data], { type: 'application/octet-stream;charset=utf-8' });
    saveAs(blob, name + this.txtExtension);
  }

  /**
   * Is warp text column
   * @param wrapTextCols example ['A', 'B', 'C']
   * @param colKey example 'A1'
   * @protected
   */
  protected isWrapTextColumn(wrapTextCols: string[], colKey: string) {
    return wrapTextCols.some(col => colKey.includes(col));
  }
}
